import React, { useState, useEffect } from 'react';
import Sidebar from '../mini-comp/Sidebar';
import Topbar from '../mini-comp/Topbar';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';

const ExpandableText = ({ text, maxLength = 100 }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  if (!text || text.length <= maxLength) return <span>{text}</span>;
  return (
    <span>
      {isExpanded ? text : `${text.substring(0, maxLength)}...`}
      <button 
        onClick={() => setIsExpanded(!isExpanded)} 
        className="btn btn-link p-0 ms-1 fs-12 text-primary"
        style={{ textDecoration: 'none', verticalAlign: 'baseline' }}
      >
        {isExpanded ? 'Show less' : 'Show more'}
      </button>
    </span>
  );
};

const Updates = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = Cookies.get('token');
        const response = await axios.get('https://inv.burrayhr.com/web/announcements/', {
          headers: {
            'Content-Type': 'application/json',
          }
        });
        const responseData = response.data.results || response.data || [];
        setData(Array.isArray(responseData) ? responseData : []);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching updates:', error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <div>
      <Topbar />
      <Sidebar />
      <div className="app-content-area">
        <div className="app-content-wrap">
          <div className="container-fluid">
            
            <div className="d-flex justify-content-between align-items-center mb-4">
              <h4 className="d-flex-items gap-10 m-0">Updates <span className="badge bg-label-primary">{data.length}</span></h4>
              <button className="btn btn-primary-light btn-sm" onClick={() => navigate('/admin/website-analytics')}>Back to Analytics</button>
            </div>

            <div className="row">
              {loading ? (
                <div className="col-12 text-center py-5">
                  <span className="text-muted">Loading...</span>
                </div>
              ) : data.length > 0 ? (
                data.map((item, idx) => {
                  const keys = Object.keys(item).filter(k => k !== 'id' && k !== 'cover' && !k.endsWith('_id') && typeof item[k] !== 'object');
                  const coverImage = item.cover || null;

                  return (
                    <div className="col-xxl-3 col-xl-4 col-lg-4 col-md-6 mb-4" key={item.id || idx}>
                      <div className="card h-100 shadow-sm border-0">
                        {coverImage && (
                          <img src={`http://inv.burrayhr.com/${coverImage}`} className="card-img-top" alt="Cover" style={{ height: '200px', objectFit: 'cover' }} />
                        )}
                        <div className="card-body">
                          {keys.map((key, i) => {
                            const val = item[key] !== null && item[key] !== undefined ? String(item[key]) : 'N/A';
                            // Make the first string key look like a title if possible
                            if (i === 0 || key === 'title' || key === 'subject' || key === 'name') {
                              return <h5 className="card-title text-capitalize mb-3 text-primary" key={key}>{val}</h5>;
                            }
                            return (
                              <div key={key} className="mb-2">
                                <span className="d-block text-capitalize text-muted fs-12 mb-1">{key.replace(/_/g, ' ')}</span>
                                <span className="d-block" style={{ wordBreak: 'break-word' }}>
                                  <ExpandableText text={val} maxLength={100} />
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="col-12 text-center py-5">
                  <span className="text-muted">No updates found</span>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Updates;